// extracted by mini-css-extract-plugin
export default {"canvas":"Canvas_canvas__WNUyo","empty":"Canvas_empty__NO6qY","emptyTitle":"Canvas_emptyTitle__8ecx5","emptyHint":"Canvas_emptyHint__-o61f"};